<template>
  <v-dialog v-model="value" persistent max-width="500px">
    <v-form
      ref="connectForm"
      v-model="valid"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('companies.connect_dialog_title', {company: company.name})}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row >
              <v-col cols="12">
                <v-text-field
                  v-model="ref"
                  :label="$t('companies.reference')+'*'"
                  :rules="[value => !!value || $t('general.required_field')]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="groups"
                  :items="savedGroups"
                  :search-input.sync="search"
                  :label="$t('companies.groups')"
                  multiple
                  small-chips
                  hide-selected
                  deletable-chips
                >
                  <template v-slot:no-data>
                    <div class="px-3" v-if="search">
                      <p v-html="$t('general.combobox_no_results', {'search': search})"></p>
                    </div>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('input', false)">{{ $t('buttons.close') }}</v-btn>
          <v-btn color="accent" text @click="connectWith()">{{ $t('companies.connect') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { companyService } from '@/_services'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CompanyConnectDialog',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    company: Object
  },
  data () {
    return {
      valid: true,
      ref: '',
      groups: [],
      search: null
    }
  },
  computed: {
    ...mapState(['signedInCompany']),
    savedGroups () {
      return companyService.getCreatedCompanyGroups(this.signedInCompany.id)
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    async connectWith () {
      if (this.$refs['connectForm'].validate()) {
        // TODO: connect with organization (API request)
        // TODO: show snackbar
        const result = await companyService.connectOrganizationInput(this.signedInCompany.id, { ref: this.ref, groups: this.groups })
        let snackMsg = ''
        let snackColor = ''
        if (result.err) {
          snackMsg = this.$i18n.t('snackbars.error')
          snackColor = 'errorr'
        } else {
          snackMsg = 'Company was connected'
          snackColor = 'success'
        }
        this.showSnackbar({ message: snackMsg, color: snackColor })
        // console.log('Company name - signedIn:', this.signedInCompany.name)
        // console.log('Company name - connected:', this.company.name)
        // console.log('ref:', this.ref)
        // console.log('groups:', this.groups)
        this.$emit('input', false)
        this.ref = ''
        this.groups = []
      }
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
